export const defaultRegistryUrls = [
  'https://jsr.io/',
  // the "https://npm.jsr.io" npm compatible registry api url
  // it contains more information than above, but less accuracy
  // https://jsr.io/docs/api#npm-compatibility-registry-api
  // > Note: The data served from the npm compatibility registry API may not always
  // > be up to date or consistent with the data served from the JSR registry API.
];
